export const findMyFriendsFeaturesList = [
    {
        id: '1',
        title: 'Live Location Sharing',
        content: 'Skip the “Where are you?” texts and see exactly where your friends are. Whether you’re making sure they got home safely or checking if they’re still in bed when you have plans, live tracking keeps everyone in sync.',
        imgName: 'multiDeviceCarousel'
    },
    {
        id: '',
        title: 'Instant Messaging',
        content: "Keep your chats and locations in one place. Message your friends right in the app for quick updates without switching apps.",
        imgName: 'messegesCarousel'
    },
    {
        id: '3',
        title: 'Directions',
        content: 'Need to find your friend in a busy place? Get Google Maps directions to their exact coordinates without the back-and-forth texting and vague instructions.',
        imgName: 'friendsLocationCarousell'
    },
    {
        id: '4',
        title: 'Check-In Feature',
        content: 'A quick way to let your friends know you’ve arrived or made it home safely, with no extra messages needed.',
        imgName: 'checkInCarousel'
    },
];